module.exports = __webpack_public_path__ + "images/花筑院子全景_09.jpg?v=5bf0fe17";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu4/花筑院子全景_09.jpg
 ** module id = 85
 ** module chunks = 1 2
 **/